import React, { useEffect, useState } from "react";
import { Pagination } from "@mui/material";
import { getUrlParam } from "libs/helper/utils";
import { Row, Select } from "saladsoft-primitive";
import { setUrlParams } from "libs/helper/paramsUtil";
import { observer } from "mobx-react-lite";
import styled from "styled-components";
import SaladToggleButton from "components/input/SaladToggleButton";

const PaginationWrapper = observer(({ count, totalPages }: { count: number, totalPages: number }) => {
    const items = [
        { value: '20', label: '20' },
        { value: '50', label: '50' },
        { value: '100', label: '100' },
    ];

    const [itemIndex, setItemIndex] = useState<number>();

    const handleChangeSize = (value: string) => {
        setUrlParams({
            size: value,
            page: '1',
        });
    };
    const handleChangePage = (event: React.ChangeEvent<unknown>, value: number) => {
        setUrlParams({
            page: value.toString(),
        });
    };

    const page = getUrlParam('page');
    const size = getUrlParam('size');
    useEffect(() => {
        setItemIndex(size ? items.findIndex(item => item.value === size) : 0);
    }, [size]);


    return (
        <Row margin={'10px 20px'} className="pagination-wrapper" background="#fff" justifyContent="space-between" width="100%">
            <CountWrapper>{count === 0
                ? '검색 결과가 없습니다.' : `total ${count} `}</CountWrapper>
            <Pagination page={page ? parseInt(page) : 1} count={totalPages} onChange={handleChangePage} variant="outlined" shape="rounded" />
            <div>
                <SaladToggleButton defaultIndex={itemIndex} items={items} onChange={handleChangeSize} />
            </div>
        </Row>
    );
});

const CountWrapper = styled.div`
    font-size: 12px;
    font-weight:700;
    color: #0099ff;
                `;

export default PaginationWrapper;